import "./MyAccount.module.css";
import Header from "@/reusable_sections/Header";
import Account from "./sections/Account";
import Footer from "@/reusable_sections/Footer";
export default function MyAccountPage() {
  return <div>
      <Header />
      <Account />
      <Footer />
    </div>;
}